import React, { useState } from 'react';
import { Download, Loader2 } from 'lucide-react';
import { salesApi, downloadAuthed } from '../api';

const istToday = () => new Date(Date.now() + 5.5 * 3600 * 1000).toISOString().slice(0, 10);

export default function ImportRunsExport() {
  const today = istToday();
  const [from, setFrom] = useState(`${today.slice(0, 8)}01`);
  const [to, setTo] = useState(today);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const invalid = !from || !to || from > to;

  const download = async () => {
    setBusy(true); setErr('');
    try { await downloadAuthed(salesApi.importRunsExportUrl(from, to), `sales-sync-history_${from}_to_${to}.xlsx`); }
    catch (e) { setErr('Download failed. Please try again.'); }
    finally { setBusy(false); }
  };

  const inputCls = 'fm-focus border border-[#E7E2D3] rounded-md px-2 py-1.5 text-[13px] bg-white';
  return (
    <div className="flex flex-wrap items-end gap-2 mb-4 p-3 rounded-md bg-[#FBF9F3] border border-[#EFEADB]" data-testid="import-runs-export">
      <label className="text-[12px] text-[#7a6f5c]">From
        <input type="date" value={from} max={today} onChange={e => setFrom(e.target.value)} data-testid="import-runs-export-from" className={`${inputCls} block mt-1`} />
      </label>
      <label className="text-[12px] text-[#7a6f5c]">To
        <input type="date" value={to} max={today} onChange={e => setTo(e.target.value)} data-testid="import-runs-export-to" className={`${inputCls} block mt-1`} />
      </label>
      <button onClick={download} disabled={busy || invalid} data-testid="import-runs-export-btn"
        className="inline-flex items-center gap-2 px-3 py-2 rounded-md border border-[#E7E2D3] bg-white text-[13px] hover:bg-[#F7F4EA] disabled:opacity-50">
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Download size={14} />} Download Excel
      </button>
      <span className="text-[12px] text-[#7a6f5c]">Two sheets: Runs and Row errors.</span>
      {invalid && <span className="text-[12px] text-[#9b2c1f]" data-testid="import-runs-export-invalid">From date must be on or before To date.</span>}
      {err && <span className="text-[12px] text-[#9b2c1f]" data-testid="import-runs-export-error">{err}</span>}
    </div>
  );
}
